import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from '../../../../core/models/general/body-list-response';
import { ResultadoDetDTO } from '../../../../core/models/evaluacion/resultadoDet-DTO';
import { BodyResponse } from '../../../../core/models/general/body-response';

const API_URL = environment.apiUrlEvaluacion;

@Injectable()
export class ResultadoDetService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getResultadoDetService() {
        return this.http.get<BodyListResponse<ResultadoDetDTO>>(
            API_URL + '/api/v1/resultadoDet/todos'
        );
    }

    guardarResultadoDetService(resultadoDetDTO: ResultadoDetDTO) {
        return this.http.post(API_URL + '/api/v1/resultadoDet', resultadoDetDTO);
    }

    getResultadoDetPorCodigoResultadoDetService(codigoResultadoDet: String) {
        return this.http.get<BodyResponse<ResultadoDetDTO>>(
            API_URL + '/api/v1/resultadoDet/' + codigoResultadoDet
        );
    }
}
